import * as React from "react";
import { cn } from "@/lib/utils";

export interface TopbarProps extends React.HTMLAttributes<HTMLDivElement> {
  crumbs?: string[];
  searchPlaceholder?: string;
  actions?: React.ReactNode;
}

export const Topbar = React.forwardRef<HTMLDivElement, TopbarProps>(
  ({ crumbs = [], searchPlaceholder = "Buscar...", actions, className, ...rest }, ref) => (
    <div
      ref={ref}
      className={cn(
        "flex h-12 shrink-0 items-center gap-4 px-6",
        "border-b border-border-subtle bg-bg-surface",
        className
      )}
      {...rest}
    >
      {crumbs.length > 0 && (
        <nav
          aria-label="Breadcrumb"
          className="flex items-center gap-1.5 text-[12px] text-text-secondary"
        >
          {crumbs.map((c, i) => (
            <React.Fragment key={i}>
              {i > 0 && <span className="text-text-disabled">/</span>}
              <span>{c}</span>
            </React.Fragment>
          ))}
        </nav>
      )}
      <div className="flex-1" />
      <div className="flex w-60 items-center gap-1.5 rounded-md border border-border-subtle bg-bg-muted-rd px-2.5 py-1 text-[12px] text-text-tertiary">
        <span>{searchPlaceholder}</span>
        <span className="ml-auto rounded-[3px] border border-border-default bg-bg-surface px-1.5 py-0.5 font-mono text-[10px] text-text-tertiary">
          ⌘K
        </span>
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  )
);
Topbar.displayName = "Topbar";
